import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  currentNodeChangedOnDirectGroupClick,
  getCurrentNode,
  getMasterGroupText,
  getQuestionOrder,
  getGroupState,
  getGroupQuestionDetailsFromQuestionTable,
  getExpressApplication,
  getExpressImportanctFactor,
  getProspectDoc
} from "../store/qf";
import CmnGroupHeader from "./CmnGroupHeader";
import MasterGroupOpenedQuestions from "./MasterGroupOpenedQuestions";
import * as theme from "../theme";

const MasterGroupHeaderAndQuestions = ({
  groupid,
  formid,
  mainDivRef,
  handleShowScroll,
  firstGroupId,
  lastGroupId,
  allinonepage,
}) => {
  // form completeness and incompleteness
  // This can be achieved by listening on the answerChanged reducer, and update the groupstate's allquestionanswered? property, and running in useEffect
  // to know if all the groups questions in answered or not. This will be achieved in next
  // version or feature.
  
  const currentnode = useSelector(getCurrentNode);
  const groupText = useSelector(getMasterGroupText(formid, groupid));
  const questionsOrder = useSelector(getQuestionOrder(formid, groupid));
  const groupState = useSelector(getGroupState(formid, groupid));
  const isExpressApplication = useSelector(getExpressApplication);
  const importanceFactor = useSelector(getExpressImportanctFactor);
  const gotProspectDetails = useSelector(getProspectDoc);
  const groupQuestionDetails = useSelector(
    getGroupQuestionDetailsFromQuestionTable({ formid, groupid, useFormState:true })
  );

  let anyIntrestedInsurer = (x) => {
    // if intresetedInsures not defined or forceImportance is true we return true
    if(!x?.interestedinsurercodes.length || x?.forceimportance){
      return true
    }
    let trex =  x.interestedinsurercodes.some((r) =>
        gotProspectDetails.interestedinsurercodes.includes(r));
      return trex
      
  }

  const [open, setOpen] = useState(true);
  const [displayGroup, setdisplayGroup] = useState("flex")
  const isFirstGroup = groupid === firstGroupId;
  const isLastGroup = groupid === lastGroupId;
  const PriorityQuestions = useMemo(() => {
    //console.log(groupQuestionDetails?.map(x => x.text))
    if(formid == 'h'){
      return groupQuestionDetails;
    }
    return groupQuestionDetails?.filter(x => (x.importance > importanceFactor && anyIntrestedInsurer(x) ) || x.answer ) || [];
  }, [groupQuestionDetails, importanceFactor, formid]);
  const isGroupOpen =
    currentnode.groupid === groupid && currentnode.formid === formid;
  const dispatch = useDispatch();

  useEffect(() => {
    let { scrollHeight, clientHeight } = mainDivRef.current;

    if (scrollHeight > clientHeight) {
      handleShowScroll(true);
      // dispatch(changeQAreaScrollThickness(true));
    } else {
      handleShowScroll(false);
      // dispatch(changeQAreaScrollThickness(false));
    }
  });

  const handleOpenCloseClick = () => {
    if (allinonepage) {
      dispatch(currentNodeChangedOnDirectGroupClick(groupid));

      if (isGroupOpen) {
        setOpen(false);
      }

      if (isGroupOpen && open === false) {
        setOpen(true);
      }
    }
  };

  useEffect(() => {
    if (isGroupOpen === true) setOpen(true);
    //if (isGroupOpen) setOpen(true);
  }, [isGroupOpen]);

  useEffect(() => {
    //console.log(PriorityQuestions)
    if(isExpressApplication && PriorityQuestions?.length == 0){
        setdisplayGroup("none")
        setOpen(false);
    }
    else{
      setdisplayGroup("flex")
    }
  }, [isExpressApplication, PriorityQuestions]);

  useEffect(() => {
    setOpen(true);
  }, [currentnode.questionid]);
  const displayStyle = displayGroup === 'none' ? 'none' : null;
  const minHeightForGroupTab = theme.SCALES.minHeightForGroupTab;
  return (
    <div style={{ minHeight: minHeightForGroupTab, display: displayStyle }}>
      <CmnGroupHeader
        text={groupText}
        isComplete={false}
        isOpen={isGroupOpen && open}
        isFirstGroup={isFirstGroup}
        isLastGroup={isLastGroup}
        handleOnClick={handleOpenCloseClick}
        allinonepage={allinonepage}
      ></CmnGroupHeader>
      {isGroupOpen && open ? (
        <MasterGroupOpenedQuestions
          questionsOrder={questionsOrder}
          formid={formid}
          groupid={groupid}
          isLastGroup={isLastGroup}
        ></MasterGroupOpenedQuestions>
      ) : null}
    </div>
  );
};

export default MasterGroupHeaderAndQuestions;
